import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectRapportDetails } from 'src/app/shared/model/object';

@Component({
  selector: 'app-status-overzicht',
  templateUrl: './status-overzicht.component.html',
  styleUrls: ['./status-overzicht.component.less']
})
export class StatusOverzichtComponent implements OnInit{

  public currentDate = new Date();
  public data: any;
  public object: ObjectRapportDetails = null;

  @Input() KlantAfkorting: string = "";
  @Input() ObjectNr :string = "";

  constructor(private objectService: ObjectenService) {

  }


  ngOnInit(): void {
    // this.objectService.getObjectRelatieStatusList('MEDNED',new Date(2022,0),new Date(2023,0)).subscribe(data => {
    //   this.data = data;
    // })
  }

  formatNumber(data: any): string {
    return Number(data).toLocaleString("nl-NL", {minimumFractionDigits: 2})
  }

  getTotaal()  {
    let totaal = 0;
    if (!this.data) return ""
    this.data.forEach(element => {
      totaal = totaal + (element.KostenEuro * 1)
    });
    return this.formatNumber(totaal);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.KlantAfkorting == "" || this.ObjectNr == "") return
    this.objectService.getObjectLevernacierStatusList(this.KlantAfkorting,
      this.ObjectNr).subscribe(data => {
      if (data.length == 0) return;
      this.data = data;
      let objectid = data[0].ID;
      this.objectService.getStatusRapportObjectDetails(objectid).subscribe(obj => {
        this.object = obj;
      })
    })
}

  print() {
    window.print();
  }


}
